// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import DatePicker from 'react-datepicker'
import moment from 'moment'

import {
  Grid,
  Button,
  Picklist,
  Spinner,
  Warning
} from '../'


const QUERY_PRODUCT_AND_EARNBACKS = gql`
  query {
    investment_products: products(family: "investments") {
      edges {
        node {
          id
          name
        }
      }
    }
    rewards_payout: products(family: "rewards", name_Icontains: "payout") {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`


export class EditForm extends Component {
  static propTypes = {
    product: PropTypes.string,
    initiateOn: PropTypes.string,
    initiateWorkflowAt: PropTypes.string
  }

  state = {
    product: this.props.product,
    initiateOnDate: this.props.initiateOn
      ? moment(this.props.initiateOn)
      : null,
    initiateWorkflowAtDate: this.props.initiateWorkflowAt
      ? moment(this.props.initiateWorkflowAt)
      : null
  }

  handleInitiateOnChange = (date) => {
    this.setState({ initiateOnDate: date })
  }
  handleInitiateWorkflowAtChange = (date) => {
    this.setState({ initiateWorkflowAtDate: date })
  }

  handleProductChange = (productName, options) => {
    const matchingProductKeyValuePair = Object.entries(options).find(([key, value]) => (
      value === productName
    ))

    this.setState({ product: matchingProductKeyValuePair[0] })
  }

  save = () => {
    let productId = this.state.product
    let initiateOn = this.state.initiateOnDate.format('YYYY-MM-DD')
    let initiateWorkflowAt = this.state.initiateWorkflowAtDate
      .utc()
      .format("YYYY-MM-DD HH:mm:ss.SSS");

    this.props.onSaveClick(productId, initiateOn, initiateWorkflowAt)
  }

  render() {
    const { onCancelClick } = this.props
    const { product, initiateOnDate, initiateWorkflowAtDate } = this.state

    const today = moment.utc()

    return (
      <Fragment>
        <Grid
          items={[
            <div className='slds-size_1-of-3'>Product:</div>,
            <Query query={QUERY_PRODUCT_AND_EARNBACKS}>
              {({ loading, error, data }) => {
                if (loading) {
                  return <Spinner size='small' className='slds-is-relative' />
                }

                if (error) {
                  return <Warning>Failed to fetch product options</Warning>
                }

                let options = {}
                data.investment_products.edges.forEach(({ node: product }) => (
                  options[product.id] = product.name
                ))
                data.rewards_payout.edges.forEach(({ node: payout }) => (
                  options[payout.id] = payout.name
                ))

                return (
                  <Picklist
                    id='product'
                    options={Object.values(options)}
                    value={options[product]}
                    onChange={productName => this.handleProductChange(productName, options)}
                    closeDropdownOnSelect={true}
                    className='slds-size_2-of-3 slds-m-bottom_medium'
                  />
                )
              }}
            </Query>,
            <div className='slds-size_1-of-3'>Initiate on:</div>,
            <div className='slds-size_2-of-3 slds-grid'>
              <DatePicker
                id='initiateOnDate'
                ref={this.dateInputRef}
                selected={initiateOnDate}
                onChange={this.handleInitiateOnChange}
                placeholderText='Choose date'
                dateFormat='DD/MM/YYYY'
                minDate={today}
                filterDate={this.isAcceptableDate}
                peekNextMonth={true}
                showMonthDropdown={true}
                dropdownMode={true}
                disabled={!product}
                className='slds-input slds-m-bottom_medium'
              />
            </div>,
            <div className='slds-size_1-of-3'>Initiate workflow at:</div>,
            <div className='slds-size_2-of-3 slds-grid'>
              <DatePicker
                id='initiateWorkflowAtDate'
                ref={this.dateInputRef}
                selected={initiateWorkflowAtDate}
                onChange={this.handleInitiateWorkflowAtChange}
                placeholderText='Choose date'
                dateFormat='DD/MM/YYYY HH:mm'
                minDate={initiateOnDate || today}
                peekNextMonth={true}
                showMonthDropdown={true}
                dropdownMode={true}
                showTimeSelect={true}
                disabled={!product || !initiateOnDate}
                className='slds-input slds-m-bottom_medium'
              />
            </div>,
          ]}
          inheritItemAsIs={true}
        />
        <div className='slds-text-align_center slds-p-top_large'>
          <Button minWidth={150} onClick={onCancelClick}>
            Cancel
          </Button>
          <Button
            type='brand'
            minWidth={150}
            disabled={!product || !initiateOnDate || !initiateWorkflowAtDate}
            onClick={this.save}>
            Save changes
          </Button>
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-batch-add-edit-modal/EditForm.js